import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import WelcomeMessageForm from '../../../components/Forms/Websites/Welcome_message/WelcomeMessageForm';

const WelcomeMessage = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('welcome_messages'));

    const columns = [
        {
            name: 'Name',
            center: 'true',
            selector: (row) => row?.name,
        },
        // {
        //     name: 'Tour Type Image',
        //     width: '100px',
        //     cell: (row) => (
        //         <img
        //             style={{ width: '100%' }}
        //             // src={`url(${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image})`}
        //             src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image}`}
        //             alt='side Img'
        //         />
        //     ),
        // },
        {
            name: 'Btn Title',
            wrap: true,
            center: 'true',
            selector: (row) => row?.btn_name,
        },
        {
            name: 'Btn Link',
            wrap: true,
            center: 'true',
            selector: (row) => row?.btn_link,
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Active',
            center: 'true',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // create new function

    const createNewServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);

        request.create('welcome_messages', formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // update

    const updateServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);

        request.updateOne('welcome_messages', selectedItem?.id, formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteServiceHandler = () =>
        request.delete('welcome_messages', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Welcome Messages List : The First Active Message Will be shown'
            buttonTitle='Add new Welcome Messages'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Welcome Messages'
                    size='lg'
                >
                    <WelcomeMessageForm apiHandler={createNewServiceHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Welcome Messages'
                    size='lg'
                >
                    <WelcomeMessageForm apiHandler={updateServiceHandler} editData={selectedItem} />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteServiceHandler}
                />
            )}
        </CardLayout>
    );
};

export default WelcomeMessage;
